import React from 'react';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom'; 

const CTA = ({authenticated, signOut}) => (
	<div>
		<div className="cta cta--reverse">
			<div className="container">
				<div className="cta__inner">
					<h2 className="cta__title" style={{fontWeight:'600', color:'#fff'}}>Sign yourself up</h2>
					<p style={{fontSize:'18px'}}className="cta__sub cta__sub--center">Join the list by answering some questions. <br/> Browse the list when you're accepted.</p>
					<Link to="/join" className="button button__accent">Take the questionnaire</Link>
				</div>
			</div>
		</div>
	</div>
);


export default CTA;



// WEBPACK FOOTER //
// ./src/views/components/cta/cta.js